import { useEffect, useState } from "react";
import { Loader2, RefreshCw, Sparkles } from "lucide-react";
import { apiGet } from "@/lib/apiAdmin";

const List = ({ title, items, testid }) => (items?.length ? (
  <div className="space-y-1.5" data-testid={testid}>
    <p className="text-[11px] uppercase tracking-widest text-gray-500">{title}</p>
    <ul className="space-y-1.5 text-sm text-gray-300 list-disc pl-4 marker:text-amber-300/60">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>
  </div>
) : null);

export const CoachAdvice = ({ month }) => {
  const [a, setA] = useState(null);
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const load = (refresh) => {
    setBusy(true);
    apiGet("/admin/coach/advice", { month, refresh }).then(setA).catch((e) => setA({ headline: e?.response?.data?.detail || "Coach is unavailable right now — try again shortly." })).finally(() => setBusy(false));
  };
  useEffect(() => { setA(null); if (open) load(false); }, [month, open]); // eslint-disable-line react-hooks/exhaustive-deps
  const h = a?.hiring;
  return (
    <div className="rounded-xl border border-amber-400/15 bg-amber-400/[0.03] p-4 space-y-4" data-testid="coach-advice">
      <div className="flex items-center gap-2">
        <Sparkles className="w-4 h-4 text-amber-300" />
        <p className="text-white text-sm flex-1">JARVIS business coach — pricing, growth & hiring</p>
        {!open
          ? <button onClick={() => setOpen(true)} className="text-xs px-3 h-8 rounded-full border border-amber-400/30 text-amber-200 hover:bg-amber-400/10 transition-colors" data-testid="coach-advice-open">Get coaching</button>
          : <button onClick={() => load(true)} disabled={busy} className="text-xs px-3 h-8 rounded-full border border-white/10 text-gray-300 hover:text-white transition-colors flex items-center gap-1" data-testid="coach-advice-refresh"><RefreshCw className={`w-3 h-3 ${busy ? "animate-spin" : ""}`} />Refresh</button>}
      </div>
      {open && (busy && !a ? <p className="text-sm text-gray-500 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />JARVIS is studying your numbers…</p> : a && <>
        {a.headline && <p className="text-amber-100 font-['Outfit']" data-testid="coach-headline">{a.headline}</p>}
        <div className="grid md:grid-cols-2 gap-5">
          <List title="Charge more" items={a.pricing} testid="coach-pricing" />
          <List title="Grow" items={a.growth} testid="coach-growth" />
          {h && <div className="space-y-1.5" data-testid="coach-hiring">
            <p className="text-[11px] uppercase tracking-widest text-gray-500">Should you hire? <span className="ml-1 px-2 py-0.5 rounded-full border border-sky-400/30 text-sky-300 normal-case tracking-normal" data-testid="coach-hiring-verdict">{h.verdict}</span></p>
            <p className="text-sm text-gray-300">{h.why}</p>
            {h.pay && <p className="text-sm text-gray-300"><span className="text-gray-500">Pay: </span>{h.pay}</p>}
            <List title="How to hire so profit goes up" items={h.how} testid="coach-hiring-how" />
          </div>}
          <List title="Testing a new hire" items={a.test_new_hires} testid="coach-test-hires" />
        </div>
      </>)}
    </div>
  );
};
